import btnStyle from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import type { SocialLinkItemType } from '@/types';
import { ActionIcon, Group, Paper, Text } from '@mantine/core';
import { useState } from 'react';
import { SocialDialog } from './SocialDialog';
export const SocialLinkItem: React.FC<SocialLinkItemType> = ({
  ...props
}) => {
  const [active, setActive] = useState<boolean>(props.active);
  return <Paper p={10} radius={5} bg="var(--bg-600)">
      <Group justify="space-between">
        <Group>
          <ActionIcon size={40} variant="filled" bg="var(--bg-500)" style={{
          pointerEvents: 'none'
        }}>
            <Icons className={props.iconClassName} fontSize={20} color="white" />
          </ActionIcon>
          <Text fz={13} tt="uppercase" c="var(--text-color-dark-theme)" fw={700}>
            {props.title}
          </Text>
        </Group>

        {active ? <ActionIcon classNames={{
        root: btnStyle.root
      }} size={40} style={{
        pointerEvents: 'none'
      }}>
            <Icons className="icon-pr-line-checked-circle-broken" fontSize={16} />
          </ActionIcon> : <SocialDialog {...props} setActive={setActive} />}
      </Group>
    </Paper>;
};